import React from "react";
import SessaoJitsiFormando from "../Jitsi/SessaoJitsiFormando";

const JitsiMeeting = () => {
    return <SessaoJitsiFormando />;
};

export default JitsiMeeting;
